import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './WorkGroupSelect.css';

/**
 * Optional work-group picker: existing group, clear, or create new inline.
 * onChange receives { workGroupId, workGroupName }
 */
function WorkGroupSelect({
  workGroups = [],
  workGroupId = '',
  workGroupName = '',
  onChange,
  disabled = false
}) {
  const { t } = useTranslation(['tasks', 'common']);
  const [mode, setMode] = useState('select');
  const [newName, setNewName] = useState('');

  const handleSelectChange = (e) => {
    const next = e.target.value;
    if (next === '__new__') {
      setMode('create');
      setNewName('');
      return;
    }
    onChange({ workGroupId: next, workGroupName: '' });
  };

  const handleCreateConfirm = () => {
    const trimmed = newName.trim();
    if (!trimmed) {
      return;
    }
    onChange({ workGroupId: '', workGroupName: trimmed });
    setMode('select');
  };

  if (workGroupName) {
    return (
      <div className="tasks-work-group-pending">
        <span className="tasks-work-group-badge tasks-work-group-badge--pending">
          {workGroupName}
        </span>
        <button
          type="button"
          className="btn btn-secondary btn-sm"
          onClick={() => onChange({ workGroupId: '', workGroupName: '' })}
          disabled={disabled}
        >
          {t('tasks:workGroupClear')}
        </button>
      </div>
    );
  }

  if (mode === 'create') {
    return (
      <div className="tasks-work-group-create">
        <input
          type="text"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          placeholder={t('tasks:workGroupNewPlaceholder')}
          disabled={disabled}
          maxLength={255}
          className="tasks-form-select-full"
        />
        <div className="tasks-work-group-create-actions">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={handleCreateConfirm}
            disabled={disabled || !newName.trim()}
          >
            {t('tasks:workGroupUseNew')}
          </button>
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={() => {
              setMode('select');
              setNewName('');
            }}
            disabled={disabled}
          >
            {t('common:cancel')}
          </button>
        </div>
      </div>
    );
  }

  const selectValue = workGroupId === '' || workGroupId == null ? '' : String(workGroupId);

  return (
    <select
      className="tasks-form-select-full"
      value={selectValue}
      onChange={handleSelectChange}
      disabled={disabled}
      aria-label={t('tasks:workGroupLabel')}
    >
      <option value="">{t('tasks:workGroupNone')}</option>
      {workGroups.map((group) => (
        <option key={group.id} value={group.id}>
          {group.name}
        </option>
      ))}
      <option value="__new__">{t('tasks:workGroupCreateNew')}</option>
    </select>
  );
}

export default WorkGroupSelect;
